export { default as WalletWithMoney } from './WalletWithMoney'
